import * as types from 'models/actionTypes'
import * as userApi from 'services/user'
import { DOWNLOAD_APP_TYPE_IOS } from 'models/user/constants'

const requestUser = () => ({
    type: types.REQUEST_USER,
})

// Notify that user has been fetched
const receiveUser = (userData) => ({
    type: types.RECEIVE_USER,
    userData,
})

const failedToReceiveUser = (error) => ({
    type: types.FAILED_RECEIVE_USER,
    error,
})

const signingupUser = () => ({
    type: types.SIGNINGUP_USER,
})

const receiveUserSignup = (response) => ({
    type: types.RECEIVE_USER_SIGNUP,
    response,
})

const logginginUser = () => ({
    type: types.LOGGINGIN_USER,
})

const receiveUserLogin = (response) => ({
    type: types.RECEIVE_USER_LOGIN,
    response,
})

export const loginNeeded = () => ({
    type: types.LOGIN_NEEDED,
})

// Fetch and dispatch with results
export const fetchUser = () => (dispatch) => {
    dispatch(requestUser())

    return userApi
        .getUser()
        .then(({ data }) => dispatch(receiveUser(data)))
        .catch(({ response }) => dispatch(failedToReceiveUser(response.statusText)))
}

export const signupUser = (userData) => (dispatch) => {
    dispatch(signingupUser())

    return userApi
        .signupUser(userData)
        .then(({ data }) => dispatch(receiveUserSignup(data)))
        .catch(({ response }) => dispatch(receiveUserSignup(response)))
}

export const loginUser = (userData) => (dispatch) => {
    dispatch(logginginUser())

    return userApi
        .loginUser(userData)
        .then(({ data }) => dispatch(receiveUserLogin(data)))
        .catch(({ response }) => dispatch(receiveUserLogin(response)))
}

export const logoutUser = () => ({
    type: types.LOGOUT_USER,
})

export const triggerPasswordReset = (email) => ({
    type: types.TRIGGER_PASSWORD_RESET,
    email,
})

export const resetPassword = (password) => ({
    type: types.RESET_PASSWORD,
    password,
})

export const receiveTriggerPasswordReset = (status) => ({
    type: types.RECEIVE_TRIGGER_PASSWORD_RESET,
    status,
})

export const receiveResetPassword = (status) => ({
    type: types.RECEIVE_RESET_PASSWORD,
    status,
})

export const requestEarlyAccessSubscription = (email) => ({
    type: types.REQUEST_EARLY_ACCESS,
    email,
})

export const receiveEarlyAccessSubscription = (status) => ({
    type: types.RECEIVE_EARLY_ACCESS,
    status,
})

export const requestChangePassword = (currentPassword, newPassword) => ({
    type: types.REQUEST_CHANGE_PASSWORD,
    currentPassword,
    newPassword,
})

export const receiveChangePassword = (status) => ({
    type: types.RECEIVE_CHANGE_PASSWORD,
    status,
})

export const resetChangePasswordStatus = () => ({
    type: types.RESET_CHANGE_PASSWORD_STATUS,
})

export const magicEraserTutorialSeen = () => ({
    type: types.MAGIC_ERASER_TUTORIAL_SEEN,
})

export const requestAppDownloadSms = (phonenumber, app = DOWNLOAD_APP_TYPE_IOS) => ({
    type: types.REQUEST_APP_DOWNLOAD_SMS,
    phonenumber,
    app,
})

export const receiveAppDownloadSms = (status) => ({
    type: types.RECEIVE_APP_DOWNLOAD_SMS,
    status,
})

export const resetAppDownloadSmsStatus = () => ({
    type: types.RESET_APP_DOWNLOAD_SMS_STATUS,
})

export const requestDeleteUser = () => ({
    type: types.REQUEST_DELETE_USER,
})

export const requestLoginPage = (isSignup = false) => ({
    type: types.REQUEST_LOGIN_PAGE,
    isSignup,
})
